module.exports = __webpack_public_path__ + "static/media/31.3e1f4368.png";